import { useState, useEffect, useCallback } from 'react';
import { billingApi, type BillingOverview, type Plan } from '../api';

export function useBilling() {
    const [overview, setOverview] = useState<BillingOverview | null>(null);
    const [plans, setPlans] = useState<Plan[]>([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const [overviewData, plansData] = await Promise.all([
                billingApi.getOverview(),
                billingApi.getPlans(),
            ]);
            setOverview(overviewData.data);
            setPlans(plansData.data);
        } catch (err: any) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const checkout = useCallback(async (planTier: string, interval: 'month' | 'year') => {
        const { checkout_url } = (await billingApi.createCheckout(planTier, interval)).data;
        window.location.href = checkout_url;
    }, []);

    const openPortal = useCallback(async () => {
        const { portal_url } = (await billingApi.createPortal()).data;
        window.location.href = portal_url;
    }, []);

    return {
        overview,
        plans,
        loading,
        error,
        checkout,
        openPortal,
        refresh: fetchData,
        isTrialing: overview?.is_trialing ?? false,
        trialDaysLeft: overview?.trial_days_left ?? 0,
        currentTier: overview?.subscription?.plan_tier ?? 'trial',
        status: overview?.subscription?.status ?? 'unknown',
    };
}